import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { Logo } from "@/components/comiq/Logo";
import { COLORS } from "@/comiq/tokens";
import { useAuth } from "@/admin/AuthContext";
import { LayoutDashboard, Building2, Layers, MailPlus, ScrollText, UsersRound, LogOut, ListChecks, Activity, Download } from "lucide-react";

const nav = [
  { to: "/admin", icon: LayoutDashboard, label: "Dashboard", end: true },
  { to: "/admin/organizations", icon: Building2, label: "Organisasi" },
  { to: "/admin/waves", icon: Layers, label: "Gelombang" },
  { to: "/admin/instruments", icon: ListChecks, label: "Instrumen" },
  { to: "/admin/invitations", icon: MailPlus, label: "Undangan" },
  { to: "/admin/monitoring", icon: Activity, label: "Monitoring" },
  { to: "/admin/exports", icon: Download, label: "Ekspor" },
  { to: "/admin/audit", icon: ScrollText, label: "Audit" },
  { to: "/admin/team", icon: UsersRound, label: "Tim & Peran" },
];

const ROLE_LABEL = { platform_admin: "Platform Admin", research_admin: "Research Admin", analyst: "Analyst" };

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  return (
    <div className="flex min-h-screen" style={{ background: COLORS.paper }}>
      <aside className="hidden w-60 shrink-0 flex-col border-r lg:flex" style={{ borderColor: COLORS.line, background: COLORS.surfaceAlt }}>
        <div className="border-b px-5 py-4" style={{ borderColor: COLORS.line }}>
          <Logo showTagline />
        </div>
        <nav className="flex-1 p-3">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`nav-${n.label}`}
              className="mb-1 flex items-center gap-3 rounded-comiq-sm px-3 py-2.5 text-sm font-medium transition-colors"
              style={({ isActive }) => ({
                color: isActive ? COLORS.ink : COLORS.textSoft,
                background: isActive ? "rgba(242,84,27,0.08)" : "transparent",
                boxShadow: isActive ? `inset 2px 0 0 ${COLORS.orange}` : "none",
              })}
            >
              <n.icon size={17} />
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t p-4" style={{ borderColor: COLORS.line }}>
          <div className="flex items-center gap-2.5">
            {user?.picture ? (
              <img src={user.picture} alt="" className="h-8 w-8 rounded-full" />
            ) : (
              <span className="flex h-8 w-8 items-center justify-center rounded-full text-xs font-bold text-white" style={{ background: COLORS.ink }}>
                {(user?.name || user?.email || "?").slice(0, 2).toUpperCase()}
              </span>
            )}
            <div className="min-w-0 flex-1 text-xs">
              <div className="truncate font-semibold" style={{ color: COLORS.ink }} data-testid="user-name">{user?.name || user?.email}</div>
              <div style={{ color: COLORS.textSoft }}>{ROLE_LABEL[user?.role] || user?.role}</div>
            </div>
            <button onClick={doLogout} title="Keluar" data-testid="logout-btn" className="rounded-full p-1.5 transition-colors hover:bg-black/5">
              <LogOut size={15} style={{ color: COLORS.textSoft }} />
            </button>
          </div>
        </div>
      </aside>
      <main className="min-w-0 flex-1">
        <Outlet />
      </main>
    </div>
  );
}
